// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.theme-wrapper {
  height: 100%;
  width: 100%;
  background-color: black;
}

.default-theme .mat-toolbar {
  background-color: white !important;
}

.home-container {
  height: 100%;
  width: 100%;
}
.home-container .toolbar {
  width: 100%;
  display: flex;
  z-index: 10;
}
.home-container .toolbar .title,
.home-container .toolbar .logout-btn .mat-button-wrapper {
  font-family: "Source Sans Pro";
}
.home-container .toolbar.lpa-toolbar {
  background-color: white;
}
.home-container .toolbar .nav-button {
  margin: 0 10px 0 0;
}
.home-container .toolbar fa-icon {
  font-size: 24px;
}
.home-container .toolbar .branding {
  cursor: pointer;
  overflow: hidden;
  padding-top: 4px;
  text-overflow: ellipsis;
}
.home-container .toolbar .branding.center {
  text-align: center;
}
.home-container .toolbar .branding img {
  position: relative;
  top: 0px;
  left: 10px;
  height: 35px;
}
.home-container .toolbar .branding img.main-header-img {
  width: inherit;
  height: 45px;
}
.home-container .toolbar .logout-btn,
.home-container .toolbar .main-header {
  color: gray;
}
.home-container .toolbar .logout-btn .logout-label {
  display: none;
}
@media (min-width: 992px) {
  .home-container .toolbar .logout-btn .logout-label {
    display: inline;
  }
}
.home-container .toolbar .logout-btn .mat-icon {
  margin-right: 4px;
}
.home-container .toolbar .main-header .title {
  padding-left: 20px;
  line-height: 45px;
  display: inline-block;
}
.home-container .toolbar .mat-stroked-button {
  margin-right: 10px;
}
.home-container .toolbar .spacer {
  flex: 1 1 auto;
}
.home-container .toolbar mat-select {
  margin: 0 0 0 20px;
  width: 40px;
  font-size: 14px;
}
@media (max-width: 992px) {
  .home-container .toolbar .nav-button {
    min-width: 0;
    padding: 0 10px;
  }
}
.home-container .login-btn {
  font-size: 16px;
}
.home-container .wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
}
.home-container .wrapper .content {
  flex: 1 0 auto;
  overflow: hidden;
}
.home-container .wrapper .footer {
  flex: 0 0 auto;
  padding: 0 15px;
  text-align: center;
}
.home-container .wrapper .footer .row {
  padding: 10px 0;
}
.home-container .wrapper .footer .row .links a {
  transition: padding 0.5s;
  display: inline-block;
  padding: 20px 5px;
}
.home-container .wrapper .footer .row .links a:hover {
  text-decoration: none;
}
.home-container .wrapper .footer .row .links a fa-icon {
  font-size: 30px;
  width: 35px;
}
.home-container .wrapper .footer .row .links a span {
  display: inline-block;
  width: 75px;
  padding: 0 0 0 3px;
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  transition: width 0.5s;
}
@media (min-width: 992px) {
  .home-container .wrapper .footer .row .links a {
    padding: 20px 10px;
  }
}
@media (max-width: 768px) {
  .home-container .wrapper .footer .row .links a {
    padding: 20px;
  }
  .home-container .wrapper .footer .row .links a span {
    width: 0;
    padding: 0;
  }
}
@media (max-width: 576px) {
  .home-container .wrapper .footer .row .links a {
    padding: 20px 5px;
  }
}
@media (min-width: 576px) {
  .home-container .wrapper .footer .row .signature {
    position: relative;
  }
  .home-container .wrapper .footer .row .signature a {
    position: absolute;
    right: 15px;
  }
}
.home-container.authenticated .wrapper .content {
  margin-top: 64px;
}
mat-sidenav {
  width: 250px;
}
mat-sidenav .branding {
  height: 64px;
  padding: 8px 10px;
  font-size: 20px;
  font-weight: 500;
}
mat-sidenav .branding img {
  height: 48px;
  margin: 2px 10px 0 0;
}
mat-sidenav .branding span {
  position: relative;
  top: 3px;
}
mat-sidenav .mat-nav-list {
  padding-top: 0;
}`, "",{"version":3,"sources":["webpack://./projects/lpa-backoffice/src/app/app/app.component.scss"],"names":[],"mappings":"AACA;EACI,YAAA;EACA,WAAA;EACA,uBAAA;AAAJ;;AAGA;EACI,kCAAA;AAAJ;;AAGA;EACI,YAAA;EACA,WAAA;AAAJ;AACI;EAKI,WAAA;EACA,aAAA;EACA,WAAA;AAHR;AAHQ;;EAEI,8BAAA;AAKZ;AAAQ;EACI,uBAAA;AAEZ;AAAQ;EACI,kBAAA;AAEZ;AAAQ;EACI,eAAA;AAEZ;AAAQ;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;AAEZ;AADY;EACI,kBAAA;AAGhB;AADY;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,YAAA;AAGhB;AAFgB;EACI,cAAA;EACA,YAAA;AAIpB;AAAQ;;EAEI,WAAA;AAEZ;AAAQ;EACI,aAAA;AAEZ;AAAQ;EACI;IACI,eAAA;EAEd;AACF;AAAQ;EACI,iBAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,iBAAA;EACA,qBAAA;AAEZ;AAAQ;EACI,kBAAA;AAEZ;AAAQ;EACI,cAAA;AAEZ;AAAQ;EACI,kBAAA;EACA,WAAA;EACA,eAAA;AAEZ;AAAQ;EACI;IACI,YAAA;IACA,eAAA;EAEd;AACF;AACI;EACI,eAAA;AACR;AACI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AACR;AAAQ;EACI,cAAA;EACA,gBAAA;AAEZ;AAAQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;AAEZ;AADY;EACI,eAAA;AAGhB;AADoB;EACI,wBAAA;EACA,qBAAA;EACA,iBAAA;AAGxB;AAFwB;EACI,qBAAA;AAI5B;AAFwB;EACI,eAAA;EACA,WAAA;AAI5B;AAFwB;EACI,qBAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;AAI5B;AADoB;EACI;IACI,kBAAA;EAG1B;AACF;AADoB;EACI;IACI,aAAA;EAG1B;EAF0B;IACI,QAAA;IACA,UAAA;EAI9B;AACF;AADoB;EACI;IACI,iBAAA;EAG1B;AACF;AAAgB;EACI;IACI,kBAAA;EAEtB;EADsB;IACI,kBAAA;IACA,WAAA;EAG1B;AACF;AAKY;EACI,gBAAA;AAHhB;AAUA;EACI,YAAA;AARJ;AASI;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AAPR;AAQQ;EACI,YAAA;EACA,oBAAA;AANZ;AAQQ;EACI,kBAAA;EACA,QAAA;AANZ;AASI;EACI,cAAA;AAPR","sourcesContent":["@import '../../styles-variables';\n.theme-wrapper {\n    height: 100%;\n    width: 100%;\n    background-color: black;\n}\n\n.default-theme .mat-toolbar {\n    background-color: white !important;\n}\n\n.home-container {\n    height: 100%;\n    width: 100%;\n    .toolbar {\n        .title,\n        .logout-btn .mat-button-wrapper {\n            font-family: 'Source Sans Pro';\n        }\n        width: 100%;\n        display: flex;\n        z-index: 10;\n        &.lpa-toolbar {\n            background-color: white;\n        }\n        .nav-button {\n            margin: 0 10px 0 0;\n        }\n        fa-icon {\n            font-size: 24px;\n        }\n        .branding {\n            cursor: pointer;\n            overflow: hidden;\n            padding-top: 4px;\n            text-overflow: ellipsis;\n            &.center {\n                text-align: center;\n            }\n            img {\n                position: relative;\n                top: 0px;\n                left: 10px;\n                height: 35px;\n                &.main-header-img {\n                    width: inherit;\n                    height: 45px;\n                }\n            }\n        }\n        .logout-btn,\n        .main-header {\n            color: gray;\n        }\n        .logout-btn .logout-label {\n            display: none;\n        }\n        @media (min-width: map-get($grid-breakpoints, lg)) {\n            .logout-btn .logout-label {\n                display: inline;\n            }\n        }\n        .logout-btn .mat-icon {\n            margin-right: 4px;\n        }\n        .main-header .title {\n            padding-left: 20px;\n            line-height: 45px;\n            display: inline-block;\n        }\n        .mat-stroked-button {\n            margin-right: 10px;\n        }\n        .spacer {\n            flex: 1 1 auto;\n        }\n        mat-select {\n            margin: 0 0 0 20px;\n            width: 40px;\n            font-size: 14px;\n        }\n        @media (max-width: map-get($grid-breakpoints, lg)) {\n            .nav-button {\n                min-width: 0;\n                padding: 0 10px;\n            }\n        }\n    }\n    .login-btn {\n        font-size: 16px;\n    }\n    .wrapper {\n        position: absolute;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        display: flex;\n        flex-direction: column;\n        .content {\n            flex: 1 0 auto;\n            overflow: hidden;\n        }\n        .footer {\n            flex: 0 0 auto;\n            padding: 0 15px;\n            text-align: center;\n            .row {\n                padding: 10px 0;\n                .links {\n                    a {\n                        transition: padding 0.5s;\n                        display: inline-block;\n                        padding: 20px 5px;\n                        &:hover {\n                            text-decoration: none;\n                        }\n                        fa-icon {\n                            font-size: 30px;\n                            width: 35px;\n                        }\n                        span {\n                            display: inline-block;\n                            width: 75px;\n                            padding: 0 0 0 3px;\n                            overflow: hidden;\n                            text-align: left;\n                            white-space: nowrap;\n                            transition: width 0.5s;\n                        }\n                    }\n                    @media (min-width: map-get($grid-breakpoints, lg)) {\n                        a {\n                            padding: 20px 10px;\n                        }\n                    }\n                    @media (max-width: map-get($grid-breakpoints, md)) {\n                        a {\n                            padding: 20px;\n                            span {\n                                width: 0;\n                                padding: 0;\n                            }\n                        }\n                    }\n                    @media (max-width: map-get($grid-breakpoints, sm)) {\n                        a {\n                            padding: 20px 5px;\n                        }\n                    }\n                }\n                @media (min-width: map-get($grid-breakpoints, sm)) {\n                    .signature {\n                        position: relative;\n                        a {\n                            position: absolute;\n                            right: 15px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n    &.authenticated {\n        .wrapper {\n            .content {\n                margin-top: 64px;\n            }\n        }\n    }\n    @media (max-width: $toolbar-breakpoint) {}\n}\n\nmat-sidenav {\n    width: 250px;\n    .branding {\n        height: 64px;\n        padding: 8px 10px;\n        font-size: 20px;\n        font-weight: 500;\n        img {\n            height: 48px;\n            margin: 2px 10px 0 0;\n        }\n        span {\n            position: relative;\n            top: 3px;\n        }\n    }\n    .mat-nav-list {\n        padding-top: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
